import QuestionValidator from "./question_validator"

export default class FormValidator {
  constructor() {
    this.questionCards = document.querySelectorAll('.question')
  }

  isValid() {
    this.clearInvalidFields()
    return this.isAllQuestionValid()
  }

  clearInvalidFields() {
    document.querySelectorAll('.is-invalid').forEach(element => {
      element.classList.remove('is-invalid')
    })
  }

  validateQuestions() {
    return Array.from(this.questionCards).map(questionCard => {
      return new QuestionValidator(questionCard).validate()
    })
  }

  isAllQuestionValid() {
    return this.validateQuestions().every(value => value === true)
  }

}
